import { StyledCard } from '@app/components/StyledCard';
import { Box } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useTranscriptionPanelViewportMaxHeight } from '../hooks/useTranscriptionPanelViewportMaxHeight';
import { TranscriptionView } from './TranscriptionView';

const transcriptionPanelTitleMessage = defineMessage({
  id: 'fragments.transcription.panelTitle',
  defaultMessage: 'Transcripción',
});

/**
 * Transcription panel for a fragment: waits for media completion, then renders the v2 transcript UI.
 */
export function TranscriptionPanel() {
  const transcriptionPanelMaxHeight = useTranscriptionPanelViewportMaxHeight();

  return (
    <StyledCard
      title={<FormattedMessage {...transcriptionPanelTitleMessage} />}
      size="sm"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
        maxHeight: transcriptionPanelMaxHeight,
      }}
      withCardContent={false}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          pt: 1.5,
          px: 1.5,
        }}
      >
        <TranscriptionView />
      </Box>
    </StyledCard>
  );
}
